<template src="./UpdatesModal.template.html" />
<style scoped lang="scss" src="./UpdatesModal.style.scss" />
<script>
import { InternalService } from "@services";
import { marked } from "marked";
import { DateTime as Luxon } from "luxon";

export default {
    name: "UpdatesModal",

    data() {
        return {
            show: false,
            updates: [],
            moreUpdates: true,
            suppressUpdates: false,
            savedSuppressUpdates: false,
            firstLoad: true,
            numUnseen: 0,
        };
    },

    async mounted() {
        await this.getUpdatesPreference();
        await this.loadUpdates();

        if (this.firstLoad && (this.suppressUpdates || this.updates.length === 0)) {
            this.firstLoad = false;
            this.show = false;
            return;
        }

        this.show = true;
    },

    methods: {
        parseMarkdown(markdownCode) {
            return marked.parse(markdownCode);
        },

        parseDate(date) {
            return Luxon.fromISO(date).toLocaleString(Luxon.DATETIME_FULL);
        },

        openUpdatesClicked() {
            this.firstLoad = false;
            this.show = true;
            this.updates = [];
            this.moreUpdates = true;

            this.loadUpdates();
        },

        continueClicked() {
            if (this.suppressUpdates != this.savedSuppressUpdates) {
                this.setUpdatesPreference();
            }

            InternalService.acknowledgeUpdates();

            this.numUnseen = 0;
            this.show = false;
        },

        async loadUpdates() {
            let params = {
                ["paging.takeNum"]: 3,
                ["paging.skipNum"]: this.updates.length,
                ["paging.orderByField"]: "PublishedOn",
                ["paging.ascending"]: false,
                unseen: this.firstLoad,
            };

            await InternalService.updates(params).then((response) => {
                if (response?.data == null) {
                    return;
                }

                this.updates.push(...response.data);

                if (response.meta?.numRemaining > 0) {
                    this.moreUpdates = true;
                } else {
                    this.moreUpdates = false;
                }

                if (this.firstLoad && response.meta?.numTotal) {
                    this.numUnseen = response.meta?.numTotal;
                }
            });
        },

        async getUpdatesPreference() {
            await InternalService.getUpdatesPreference().then((response) => {
                if (response?.data == null) {
                    return;
                }

                this.savedSuppressUpdates = response.data.suppressUpdates;
                this.suppressUpdates = response.data.suppressUpdates;
            });
        },

        async setUpdatesPreference() {
            await InternalService.setUpdatesPreference({
                suppressUpdates: this.suppressUpdates,
            });
        },
    },
};
</script>
